'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'loadingIndicator': 'tcl__LoadingIndicator-2e286961',
  'inverted': 'tcl__LoadingIndicator-b27c67bb',
  'size-18': 'tcl__LoadingIndicator-efc979e6',
  'size-24': 'tcl__LoadingIndicator-c04a1b8b',
  'size-36': 'tcl__LoadingIndicator-009c41a3',
  'size-48': 'tcl__LoadingIndicator-f48484cd'
};

/**
 * Loading indicator component.
 */

var LoadingIndicator = function LoadingIndicator(_ref) {
  var _classnames;

  var className = _ref.className,
      isInverted = _ref.isInverted,
      size = _ref.size;

  var classNames = (0, _classnames3.default)(styles.loadingIndicator, (_classnames = {}, _defineProperty(_classnames, styles.inverted, isInverted), _defineProperty(_classnames, styles['size-' + size], size), _classnames), className);

  return _react2.default.createElement('span', { className: classNames });
};

LoadingIndicator.displayName = 'LoadingIndicator';
LoadingIndicator.propTypes = _extends({}, _withSpacing.propTypes, {

  /**
   * Whether the loading indicator is white or not.
   */
  isInverted: _propTypes2.default.bool,

  /**
   * Loading indicator size in px.
   */
  size: _propTypes2.default.oneOf([18, 24, 36, 48]),

  /**
   * Any additional css classes
   */
  className: _propTypes2.default.string
});

LoadingIndicator.defaultProps = {
  size: 18,
  isInverted: false,
  className: ''
};

exports.default = (0, _withSpacing2.default)(LoadingIndicator);